import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import RouteErrorBoundary from '../components/error-boundary/route-error-boundary.component';

const HomePage = lazy(() => import('../pages/home/home.page'));
const ExplorePage = lazy(() => import('../pages/explore/explore.page'));
const ProfilePage = lazy(() => import('../pages/profile/profile.page'));
const NotificationsPage = lazy(() => import('../pages/notifications/notifications.page'));
const WorkoutsPage = lazy(() => import('../pages/workouts/workouts.page'));
const WorkoutTrackerPage = lazy(() => import('../pages/workouts/workout-tracker.page'));
const WorkoutHistoryPage = lazy(() => import('../pages/workouts/workout-history.page'));
const WorkoutDetailPage = lazy(() => import('../pages/workouts/workout-detail.page'));
const WorkoutAnalyticsPage = lazy(() => import('../pages/workouts/workout-analytics.page'));
const NutritionPage = lazy(() => import('../pages/nutrition/nutrition.page'));
const NutritionLogPage = lazy(() => import('../pages/nutrition/nutrition-log.page'));
const ProgressPage = lazy(() => import('../pages/progress/progress.page'));
const MessagesPage = lazy(() => import('../pages/messages/messages.page'));
const SettingsPage = lazy(() => import('../pages/settings/settings.page'));
const SavedPage = lazy(() => import('../pages/saved/saved.page'));
const SearchPage = lazy(() => import('../pages/search/search.page'));
const PostDetailPage = lazy(() => import('../pages/post/post-detail.page'));

/**
 * Fallback loader for lazy-loaded pages.
 */
const PageFallback = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      py: 8,
      width: '100%',
    }}
    role="status"
    aria-label="Loading page"
  >
    <CircularProgress size={40} />
  </Box>
);

const DashboardRoutes = () => {
  return (
    <Suspense fallback={<PageFallback />}>
      <RouteErrorBoundary>
        <Routes>
          <Route path="/home" element={<HomePage />} />
          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/profile/:username" element={<ProfilePage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/workouts" element={<WorkoutsPage />} />
          <Route path="/workouts/log" element={<WorkoutTrackerPage />} />
          <Route path="/workouts/history" element={<WorkoutHistoryPage />} />
          <Route path="/workouts/analytics" element={<WorkoutAnalyticsPage />} />
          <Route path="/workouts/:workoutId" element={<WorkoutDetailPage />} />
          <Route path="/nutrition" element={<NutritionPage />} />
          <Route path="/nutrition/log" element={<NutritionLogPage />} />
          <Route path="/progress" element={<ProgressPage />} />
          <Route path="/messages" element={<MessagesPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/saved" element={<SavedPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/post/:postId" element={<PostDetailPage />} />

          {/* Redirect unmatched dashboard routes to home */}
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
      </RouteErrorBoundary>
    </Suspense>
  );
};

export default DashboardRoutes;
